import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ThankYouPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100); // small delay to trigger transition
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#ebeef1] px-4 py-8 sm:px-6 lg:px-8"
      style={{ fontFamily: "GT-Ultra" }}
    >
      <div className="relative z-10 mx-auto w-full max-w-md text-center sm:max-w-lg">
        {/* Logo */}
        <div
          className={`mb-8 transform transition-all duration-1000 ${
            isLoaded ? "translate-y-0 opacity-100" : "-translate-y-5 opacity-0"
          }`}
        >
          <div className="mx-auto flex h-16 items-center justify-center rounded-2xl">
            <img src="/assets/imgs/CenturyLogo.png" alt="Century Group Logo" />
          </div>
        </div>

        {/* Thank You Message */}
        <div
          className={`mb-4 mt-8 transition-all delay-150 duration-1000 ${
            isLoaded ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
          }`}
        >
          <h1 className="mb-4 text-3xl font-bold text-gray-800 drop-shadow-lg">
            Thank You!
          </h1>
          <p className="text-lg leading-relaxed text-gray-700">
            Your response has been successfully recorded.
            {/* <br /> */}
            {/* We appreciate your time and will be in touch if necessary. */}
          </p>
        </div>

        {/* Back to Home Button */}
        <div
          className={`transition-all delay-300 duration-1000 ${
            isLoaded ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
          }`}
        >
          <Link
            to="/"
            className="inline-block rounded-lg bg-[#1a4fa3] px-6 py-3 text-white transition-all duration-300 hover:bg-blue-700"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
